// Executive KPI copy only. Values, comparisons and target calculations stay in App.
import { createContext, useContext, type ReactNode } from "react";
import { useDesktopInformation } from "./desktopInformation";
import "./executiveKpiPresentation.css";

const ExecutiveKpiContext = createContext(false);

export function ExecutiveKpiPresentation({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  const desktop = useDesktopInformation();
  return <ExecutiveKpiContext.Provider value={enabled && desktop}>{children}</ExecutiveKpiContext.Provider>;
}

export function useExecutiveKpiPresentation() {
  return useContext(ExecutiveKpiContext);
}

export function executiveKpiTitle(label: string, fallback: string, t: (text: string) => string, active: boolean) {
  if (!active) return fallback;
  if (label === "Satılan Adet") return t("Adet");
  if (label === "Sellthrough") return t("Sell-through");
  return fallback;
}

export function ExecutiveKpiPreviousLabel({ original }: { original: string }) {
  return <span>{useExecutiveKpiPresentation() ? "LY" : original}</span>;
}

export function ExecutiveKpiChange({ original, translated }: { original: string; translated: string }) {
  const active = useExecutiveKpiPresentation();
  const isComparison = /^[+-]?[\d.,]+% vs LY$/.test(original);
  return active && isComparison ? translated.match(/^[+-]?[\d.,]+%/)?.[0] ?? translated : translated;
}
